(function () {
  var api = window.NCProductStickyPurchaseBar || {};
  var INTRO_BUTTON_SELECTOR = "[data-product-intro-preorder]";
  var FOOTER_SELECTOR = "footer";

  function setVisible(root, isVisible) {
    var button = root.querySelector("[data-nc-product-sticky-purchase-button]");

    root.classList.toggle("is-visible", isVisible);
    root.setAttribute("aria-hidden", isVisible ? "false" : "true");

    if (button) {
      button.setAttribute("tabindex", isVisible ? "0" : "-1");
    }
  }

  function resetRoot(root) {
    if (!root) return;

    if (root.ncProductStickyPurchaseBarObserver) {
      root.ncProductStickyPurchaseBarObserver.disconnect();
    }

    delete root.ncProductStickyPurchaseBarObserver;
    delete root.ncProductStickyPurchaseBarState;
    delete root.dataset.ncProductStickyPurchaseBarInitialized;

    setVisible(root, false);
  }

  function initRoot(root) {
    if (!root || root.dataset.ncProductStickyPurchaseBarInitialized === "true") return;

    var introButton = document.querySelector(INTRO_BUTTON_SELECTOR);
    var footer = document.querySelector(FOOTER_SELECTOR);

    root.dataset.ncProductStickyPurchaseBarInitialized = "true";

    if (!introButton || !("IntersectionObserver" in window)) {
      setVisible(root, false);
      return;
    }

    var state = {
      isIntroButtonVisible: true,
      isFooterVisible: false
    };

    function updateVisibility() {
      setVisible(root, !state.isIntroButtonVisible && !state.isFooterVisible);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === introButton) {
            state.isIntroButtonVisible = entry.isIntersecting;
          }

          if (footer && entry.target === footer) {
            state.isFooterVisible = entry.isIntersecting;
          }
        });

        updateVisibility();
      },
      { threshold: [0, 0.1] }
    );

    observer.observe(introButton);

    if (footer) {
      observer.observe(footer);
    }

    root.ncProductStickyPurchaseBarObserver = observer;
    root.ncProductStickyPurchaseBarState = state;
    updateVisibility();
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-product-sticky-purchase-bar]")
      : [];

    if (scope.matches && scope.matches("[data-nc-product-sticky-purchase-bar]")) {
      initRoot(scope);
    }

    roots.forEach(initRoot);
  }

  function resetAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-product-sticky-purchase-bar]")
      : [];

    if (scope.matches && scope.matches("[data-nc-product-sticky-purchase-bar]")) {
      resetRoot(scope);
    }

    roots.forEach(resetRoot);
  }

  api.initAll = initAll;
  api.resetAll = resetAll;
  window.NCProductStickyPurchaseBar = api;

  if (!window.__ncProductStickyPurchaseBarEventsBound) {
    window.__ncProductStickyPurchaseBarEventsBound = true;

    document.addEventListener("DOMContentLoaded", function () {
      window.NCProductStickyPurchaseBar.initAll(document);
    });

    document.addEventListener("shopify:section:load", function () {
      window.NCProductStickyPurchaseBar.resetAll(document);
      window.NCProductStickyPurchaseBar.initAll(document);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      window.NCProductStickyPurchaseBar.resetAll(event.target);
    });
  }

  if (document.readyState !== "loading") {
    window.NCProductStickyPurchaseBar.initAll(document);
  }
})();
